import GAContractList from './List';
import GAContractEdit from './Edit';

const GAContractLabel = "GA Request List";

export { GAContractList, GAContractEdit, GAContractLabel};
